export enum PatientResponseIdentifier {
  PhoneNumber = 'phoneNumber',
  SSN = 'ssn',
}
